// Choix « Lier à un rapport » d'une note de suivi : rapports en cours (brouillons) puis rapports envoyés.

export function draftOptionLabel(draft) {
  const parts = [draft?.date_start, draft?.agent_name].filter(Boolean);
  return `Rapport en cours (brouillon) — ${parts.length ? parts.join(', ') : 'sans date'}`;
}

export function reportOptionLabel(report) {
  const date = report?.date_start || '?';
  return `Nuit du ${date}${report?.agent_name ? ` · ${report.agent_name}` : ''}`;
}

/**
 * Groupes d'options pour le sélecteur. Un identifiant n'apparaît qu'une fois
 * (un rapport déjà envoyé l'emporte sur son brouillon). Le lien actuel d'une note
 * reste proposé même s'il n'est plus dans les listes (brouillon supprimé).
 */
export function buildReportOptions({ drafts = [], reports = [], currentId = '', currentStatus = null } = {}) {
  const sentIds = new Set(reports.map((report) => report.id));
  const draftOptions = drafts
    .filter((draft) => draft?.id && !sentIds.has(draft.id))
    .map((draft) => ({ value: draft.id, label: draftOptionLabel(draft), kind: 'draft' }));
  const reportOptions = reports
    .filter((report) => report?.id)
    .map((report) => ({ value: report.id, label: reportOptionLabel(report), kind: 'report' }));
  const known = new Set([...draftOptions, ...reportOptions].map((option) => option.value));
  const current = currentId && !known.has(currentId)
    ? [{ value: currentId, label: currentStatus === 'missing' ? 'Lien actuel : brouillon supprimé' : 'Rapport déjà lié', kind: 'current' }]
    : [];
  return { current, drafts: draftOptions, reports: reportOptions };
}

/** Texte affiché sous une note liée. */
export function linkStatusText(note) {
  if (!note?.report_id) return '';
  if (note.report_status === 'draft') {
    const draft = note.report_draft || {};
    return draftOptionLabel(draft);
  }
  if (note.report_status === 'missing') return 'Rapport lié : brouillon supprimé';
  return '';
}
